import { render } from "./df-ui2-header.vue?vue&type=template&id=21bd5d00&scoped=true"
import script from "./df-ui2-header.vue?vue&type=script&lang=js"
export * from "./df-ui2-header.vue?vue&type=script&lang=js"

import "./df-ui2-header.vue?vue&type=style&index=0&id=21bd5d00&scoped=true&lang=scss"

import exportComponent from "D:\\phpEnv\\www\\zy\\frontend\\zhiyadu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21bd5d00"]])

export default __exports__